(() => {
  if (window.ebikebuyerFilterScrollReady) return;
  window.ebikebuyerFilterScrollReady = true;
  const desktop = window.matchMedia('(min-width: 1280px)');
  let frame = 0, panel = null, container = null, savedScrollTop = 0;
  const sizes = new ResizeObserver(schedule);
  const replacements = new MutationObserver(schedule);

  function rememberScroll() {
    savedScrollTop = panel.scrollTop;
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function update() {
    frame = 0;
    const nextContainer = document.getElementById('FacetFiltersContainer');
    if (nextContainer !== container) {
      replacements.disconnect();
      container = nextContainer;
      if (container) replacements.observe(container, {childList: true});
    }
    const next = container?.querySelector(':scope > .sticky-element') || null;
    const replaced = next !== panel;
    if (replaced) {
      if (panel) {
        sizes.unobserve(panel);
        panel.removeEventListener('scroll', rememberScroll);
      }
      panel = next;
      if (panel) {
        sizes.observe(panel);
        panel.addEventListener('scroll', rememberScroll, {passive: true});
      }
    }
    if (!panel) return;
    if (!desktop.matches) {
      panel.style.removeProperty('--ebikebuyer-filter-max-height');
      return;
    }
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const stickyTop = Math.max(0, Number.parseFloat(getComputedStyle(panel).top) || 0);
    const maximum = Math.max(0, viewportHeight - stickyTop - 16);
    const visible = viewportHeight - Math.max(stickyTop, panel.getBoundingClientRect().top) - 16;
    const height = Math.floor(Math.min(maximum, Math.max(Math.min(160, maximum), visible)));
    const value = height + 'px';
    if (panel.style.getPropertyValue('--ebikebuyer-filter-max-height') !== value) {
      panel.style.setProperty('--ebikebuyer-filter-max-height', value);
    }
    if (replaced) panel.scrollTop = savedScrollTop;
  }

  sizes.observe(document.documentElement);
  new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  desktop.addEventListener('change', schedule);
  document.addEventListener('collection:rerendered', schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
